<div
  *ngIf="showModal"
  id="passwordModal3"
  class="modal fixed inset-0 bg-black bg-opacity-70 flex items-start justify-center z-50 overflow-y-auto"
  (click)="onHide()"
>
  <div
    class="relative card_color rounded-lg max-w-md w-full flex flex-col md:flex-row text_white overflow-hidden shadow-lg mx-4 sm:mx-8 my-10 max-h-[90vh] overflow-y-auto"
    (click)="$event.stopPropagation()"
  >
    <!-- Botón de cierre -->
    <button
      class="close-modal absolute top-4 right-4 text_gray hover:text_white text-2xl font-bold"
      (click)="onHide()"
    >
      &times;
    </button>

    <!-- Formulario de inicio de sesión -->
    <div
      class="w-full p-6 sm:p-8 flex flex-col justify-center card_color rounded-b-lg md:rounded-r-lg md:rounded-bl-none"
    >
      <div class="mb-4">
        <img
          [src]="logo ? logo : 'assets/images/no-photo-available.png'"
          alt="Logo"
          class="mx-auto"
          width="200"
          height="60"
        />
      </div>

      <h2 class="text-xl sm:text-2xl font-medium mb-2 text-left">
        Establecer Nueva Contraseña
      </h2>
      <p class="text-md font-light mb-2 sm:mb-3">
        Establece una nueva contraseña para iniciar sesión en tu cuenta.
      </p>

      <form class="space-y-4" [formGroup]="restorePasswordForm">
        <!-- Primer campo de "Establecer contraseña" -->
        <div class="relative w-full">
          <!-- Ícono de candado a la izquierda -->
          <div
            class="absolute inset-y-0 left-3 flex items-center pointer-events-none"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="text_color_customize icon icon-tabler icons-tabler-outline icon-tabler-lock-password"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path
                d="M5 13a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z"
              />
              <path d="M8 11v-4a4 4 0 1 1 8 0v4" />
              <path d="M15 16h.01" />
              <path d="M12.01 16h.01" />
              <path d="M9.02 16h.01" />
            </svg>
          </div>
          <!-- Input para establecer contraseña -->
          <input
            formControlName="newPassword"
            [type]="showNewPassword ? 'text' : 'password'"
            id="password2"
            maxlength="16"
            placeholder="Nueva Contraseña"
            class="w-full pl-10 pr-10 p-3 text-md bg_color text_white placeholder_gray_customize rounded-lg focus_line_customize focus_line_color_customize"
          />
          <!-- Ícono de ojo para mostrar/ocultar contraseña a la derecha -->
          <div
            class="absolute inset-y-0 right-3 flex items-center cursor-pointer"
            (click)="showNewPassword = !showNewPassword"
          >
            <svg
              id="eye-icon-password1"
              xmlns="http://www.w3.org/2000/svg"
              class="icon icon-tabler icon-tabler-eye w-5 h-5 text_color_customize"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              fill="none"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M12 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
              <path
                d="M22 12c-2.667 -4 -5.333 -6 -8 -6s-5.333 2 -8 6c2.667 4 5.333 6 8 6s5.333 -2 8 -6"
              />
            </svg>
          </div>
        </div>
        <small
          style="color: #fc6161"
          *ngIf="
            restorePasswordForm.get('newPassword')?.dirty &&
            restorePasswordForm.get('newPassword')?.hasError('custom')
          "
          class="p-invalid"
          >{{ restorePasswordForm.get("newPassword")?.getError("custom")
          }}</small
        >

        <!-- Segundo campo de "Confirmar contraseña" -->
        <div class="relative w-full">
          <div
            class="absolute inset-y-0 left-3 flex items-center pointer-events-none"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="text_color_customize icon icon-tabler icons-tabler-outline icon-tabler-lock-password"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path
                d="M5 13a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z"
              />
              <path d="M8 11v-4a4 4 0 1 1 8 0v4" />
              <path d="M15 16h.01" />
              <path d="M12.01 16h.01" />
              <path d="M9.02 16h.01" />
            </svg>
          </div>
          <input
            formControlName="confirmPassword"
            [type]="showConfirmPassword ? 'text' : 'password'"
            type="password"
            id="password3"
            maxlength="16"
            placeholder="Confirmar Nueva Contraseña"
            class="w-full pl-10 pr-10 p-3 text-md bg_color text_white placeholder_gray_customize rounded-lg focus_line_customize focus_line_color_customize"
          />
          <div
            class="absolute inset-y-0 right-3 flex items-center cursor-pointer"
            (click)="showConfirmPassword = !showConfirmPassword"
          >
            <svg
              id="eye-icon-password2"
              xmlns="http://www.w3.org/2000/svg"
              class="icon icon-tabler icon-tabler-eye w-5 h-5 text_color_customize"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              fill="none"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M12 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
              <path
                d="M22 12c-2.667 -4 -5.333 -6 -8 -6s-5.333 2 -8 6c2.667 4 5.333 6 8 6s5.333 -2 8 -6"
              />
            </svg>
          </div>
        </div>
        <small
          style="color: #fc6161"
          *ngIf="
            restorePasswordForm.get('confirmPassword')?.dirty &&
            restorePasswordForm.get('confirmPassword')?.hasError('custom')
          "
          class="p-invalid"
          >{{ restorePasswordForm.get("confirmPassword")?.getError("custom")
          }}</small
        >

        <button
          type="submit"
          class="open-login-modal-01 w-full my-2 block py-3 font-normal text-center text_white hover:text_black button_color_customize hover:button_color_customize font-medium rounded-lg"
          (click)="changePassword()"
          [disabled]="
            restorePasswordForm.controls['newPassword'].invalid ||
            restorePasswordForm.controls['confirmPassword'].invalid ||
            processing
          "
          [class.pointer-events-none]="
            restorePasswordForm.controls['newPassword'].invalid ||
            restorePasswordForm.controls['confirmPassword'].invalid ||
            processing
          "
        >
          <div class="inline-flex items-center">Confirmar</div>
        </button>
      </form>
    </div>
  </div>
</div>
